import { render, staticRenderFns } from "./eslroleadd.vue?vue&type=template&id=2edec5e0&scoped=true"
import script from "./eslroleadd.vue?vue&type=script&lang=js"
export * from "./eslroleadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edec5e0",
  null
  
)

export default component.exports